<template>
  <article id="week-calendar">
    <div class="navigation" v-if="navigationTop">
      <div class="btn-navigation">
        <button @click="changeWeek('previous')">
          <Icon icon="fas fa-angle-left" />
        </button>
        <button @click="changeWeek('today')">Aujourd'hui</button>
        <button @click="changeWeek('next')">
          <Icon icon="fas fa-angle-right" />
        </button>
      </div>
    </div>

    <VueSlickCarousel
      ref="carousel"
      :swipe="isTouchDevice"
      :arrows="false"
      :initialSlide="1"
      :infinite="false"
      :speed="ANIMATION_TIME"
      @afterChange="afterChange"
    >
      <div v-for="(days, weekIndex) in weeks" :key="weekIndex">
        <Week
          :updatable="updatable"
          :selectable="selectable"
          :selectedMealsId="selectedMealsId"
          :days="days"
        />
      </div>
    </VueSlickCarousel>
  </article>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import _ from 'lodash';

import Week from './Week.vue';

import utilsService from '../../services/utils.service';

// Animation swipe
const ANIMATION_TIME = 200;
// = combien de semaines dans le passé
const DEFAULT_ARRAY_INDEX = 10;

export default {
  components: {
    Week,
    VueSlickCarousel,
  },
  props: {
    updatable: {
      type: Boolean,
      default: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selectedMealsId: {
      type: Array,
      default: () => [],
    },
    navigationTop: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      ANIMATION_TIME,
      weeks: [],
      selected: [],
      currentIndex: 0,
    };
  },
  created() {
    // On crée un tableau vide d'une taille minimum
    for (let i = 0; i < DEFAULT_ARRAY_INDEX; i += 1) {
      this.weeks.push([]);
    }
    this.calculateDefaultWeeks();
  },
  mounted() {
    // On va à la semaine actuelle
    this.$refs.carousel.goTo(DEFAULT_ARRAY_INDEX);
    this.currentIndex = DEFAULT_ARRAY_INDEX;
  },

  methods: {
    /**
     * Par défaut, 3 semaines
     */
    calculateDefaultWeeks() {
      const prevWeek = utilsService.getPreviousWeek();
      this.weeks[DEFAULT_ARRAY_INDEX - 1] = prevWeek;
      const currentWeek = utilsService.getCurrentWeek();
      this.weeks[DEFAULT_ARRAY_INDEX] = currentWeek;
      const nextWeek = utilsService.getNextWeek();
      this.weeks.push(nextWeek);
    },

    /**
     * Quand on change de semaine
     */
    changeWeek(data) {
      if (data === 'previous') {
        this.$refs.carousel.prev();
      } else if (data === 'next') {
        this.$refs.carousel.next();
      } else if (data === 'today') {
        this.$refs.carousel.goTo(DEFAULT_ARRAY_INDEX);
      }
    },

    /**
     * Après avoir changé de page sur le carousel
     */
    afterChange(slideIndex) {
      // On regarde le tableau avant et après la semaine actuelle
      const shouldCalcNext = _.get(this.weeks, slideIndex + 1, []).length === 0;
      const shouldCalcPrev =
        slideIndex > 0 && _.get(this.weeks, slideIndex - 1, []).length === 0;

      // On ajoute le semaine suivante
      if (shouldCalcNext) {
        const lastWeek = this.weeks[this.weeks.length - 1];
        const lastDay = lastWeek[lastWeek.length - 1];
        const nextWeek = utilsService.getNextWeek(lastDay);
        this.weeks.push(nextWeek);
      }
      // On ajoute la semaine précédente
      if (shouldCalcPrev) {
        const firstDay = this.weeks[slideIndex][0];
        const prevWeek = utilsService.getPreviousWeek(firstDay);
        if (slideIndex > 0) {
          // Force array to refresh
          this.$set(this.weeks, slideIndex - 1, prevWeek);
        }
      }
      // On MAJ l'index
      this.currentIndex = slideIndex;
    },

    /**
     * Retourne tous les selectedMeals des Week affichées
     */
    getSelectedPlannedMeals() {
      const selected = [];
      console.log('TODO : refs.weeks.foreach');
      return selected;
    },
  },
};
</script>

<style lang="scss" scoped src="./WeekCalendar.scss"></style>
